import { createFileRoute } from "@tanstack/react-router";
import { ServiceLayout } from "@/components/ServiceLayout";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/services/tax-preparation")({
  head: () => ({
    meta: [
      ...routeMeta("/services/tax-preparation"),
      { title: "Tax Preparation in Winter Garden, FL | CCOB And Company PA" },
      { name: "description", content: "Individual and business tax returns prepared by a licensed CPA in Winter Garden — accurate, timely, and reviewed for every legal deduction." },
      { property: "og:title", content: "Tax Preparation — CCOB And Company PA" },
      { property: "og:description", content: "Federal and state tax returns for individuals, families, and businesses." },
    ],
    links: canonicalLinks("/services/tax-preparation"),
  }),
  component: () => (
    <ServiceLayout
      eyebrow="Tax Preparation"
      title="Tax Returns Prepared by a CPA — Not a Seasonal Storefront"
      subtitle="Accurate filings. Every legal deduction. Reviewed before it's signed."
      hero={img.heroTax}
      image={img.taxPrep}
      intro="Whether your return is a simple W-2 or a multi-state S-Corp with K-1s, the same licensed CPA prepares it, reviews it, and signs it. No outsourcing, no last-minute surprises, no missed deductions."
      items={[
        { title: "Individual Tax Returns (1040)", desc: "Federal and state returns including itemized deductions, investment income, and rental properties." },
        { title: "Business Tax Returns", desc: "S-Corp (1120-S), C-Corp (1120), Partnership (1065), and Schedule C — done by the CPA who knows your books." },
        { title: "Multi-State Filings", desc: "Returns for clients with income in multiple states, including non-resident allocations." },
        { title: "Estate, Trust & Gift Returns", desc: "Form 1041 for estates and trusts, Form 706 for estates, and Form 709 for gift taxes." },
        { title: "Amended & Late Returns", desc: "Prior-year corrections (1040-X) and back-tax filings handled discreetly." },
        { title: "Year-Round Q&A", desc: "Quick questions during the year answered — not just the week before the deadline." },
      ]}
    />
  ),
});
